import React from "react";
import "../styles/Banner.css";

const Banner = () => {
  return (
    <header className="banner">
      <div className="banner-content">
        <h1>VPN Console</h1>
      </div>
    </header>
  );
};

export default Banner;
